import { FC } from 'react';
import { Users, Search } from 'lucide-react';

interface ClientsEmptyStateProps {
  /** Whether this is a "no results" state (from search) vs "no clients" state */
  isSearchEmpty?: boolean;
  /** The search query that returned no results */
  searchQuery?: string;
}

export const ClientsEmptyState: FC<ClientsEmptyStateProps> = ({
  isSearchEmpty = false,
  searchQuery = '',
}) => {
  if (isSearchEmpty) {
    return (
      <div className="bg-gray-50 dark:bg-slate-800/50 rounded-lg p-8 text-center border border-gray-200 dark:border-slate-700">
        <Search className="w-12 h-12 text-gray-300 dark:text-slate-600 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-gray-700 dark:text-slate-300 mb-2">
          No Clients Found
        </h3>
        <p className="text-gray-500 dark:text-slate-400">
          No clients match "{searchQuery}". Try a different search term.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-slate-100">Clients</h2>
          <p className="text-gray-600 dark:text-slate-400 mt-1">
            Manage your client relationships
          </p>
        </div>
      </div>
      <div className="bg-gray-50 dark:bg-slate-800/50 rounded-lg p-12 text-center border border-gray-200 dark:border-slate-700">
        <Users className="w-16 h-16 text-gray-300 dark:text-slate-600 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-gray-700 dark:text-slate-300 mb-2">
          No Clients Yet
        </h3>
        <p className="text-gray-500 dark:text-slate-400 max-w-sm mx-auto">
          Once clients book appointments with you, they will appear here. You can track their
          history and add notes.
        </p>
      </div>
    </div>
  );
};
